import { CSSProperties } from 'react';
import clsx from 'clsx';
import styles from './KeyOfficialsCreditSummary.module.scss';
import CreditProgessBar from './Components/CreditProgessBar';
import { ctaPurpleRight } from '../../../../../../assets/hostedassets';
import { MAX_BUREAU_SCORE } from '../Report/CreditBureauConstants';

interface UnifiedBureauReportRowProps {
    isAllTab: boolean;
    loading: boolean;
    minScore?: number | null;
    maxScore?: number | null;
    logoUrl?: string;
    logoStyle?: CSSProperties;
    onOpenReport: () => void;
}

// Relocated "Combined Director Report" CTA. Clickable (score + bar) on a bureau tab, guidance on ALL.
// Co-located with KeyOfficialsCreditSummary; kept in its own file so it can be unit-tested without
// pulling in the parent module's heavy import tree.
export function UnifiedBureauReportRow({ isAllTab, loading, minScore, maxScore, logoUrl, logoStyle, onOpenReport }: UnifiedBureauReportRowProps) {
    // Primary score drives the bar + single-value display (mirrors the Combined Report: maxScore || minScore).
    const primaryScore = maxScore || minScore;
    // Show a min–max range (like the Combined Report) when the directors' scores span more than one value.
    const showRange = typeof minScore === 'number' && typeof maxScore === 'number' && minScore !== maxScore;

    const nameCell = (
        <div className={styles.Name}>
            <div>Unified Bureau Report</div>
            <div className={styles.DesignationText}>(All Directors)</div>
        </div>
    );

    if (isAllTab) {
        return (
            <div className={clsx(styles.Row, styles.UnifiedRow, styles.UnifiedDisabled)}>
                {nameCell}
                <div className={styles.UnifiedMessage}>
                    Select one individual bureau from above toggle, to view combined reports of directors.
                </div>
            </div>
        );
    }

    const bureauLogo = logoUrl && <img src={logoUrl} alt="" className={styles.BureauLogo} style={logoStyle} />;

    return (
        <div
            className={clsx(styles.Row, styles.UnifiedRow)}
            role="button"
            tabIndex={0}
            onClick={onOpenReport}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onOpenReport();
                }
            }}
        >
            {nameCell}
            {loading ? (
                // Loading — skeleton shaped like the score + bar (not the CTA, which reads as no-data).
                <div className={styles.Cibil}>
                    {logoUrl && <img src={logoUrl} alt="" className={styles.Image} style={logoStyle} />}
                    <div className={clsx(styles.CombinedSkeleton, styles.CombinedSkeletonNum)} />
                    <div className={clsx(styles.CombinedSkeleton, styles.CombinedSkeletonBar)} />
                </div>
            ) : typeof primaryScore === 'number' && primaryScore > 0 ? (
                <div className={styles.Cibil}>
                    {logoUrl && <img src={logoUrl} alt="" className={styles.Image} style={logoStyle} />}
                    {/* No "/900" suffix on the Unified row — show the range, or the single score alone. */}
                    <div>{showRange ? `${minScore}-${maxScore}` : primaryScore}</div>
                    <CreditProgessBar width={(primaryScore / MAX_BUREAU_SCORE) * 100} ParentWidth="12.5rem" />
                </div>
            ) : (
                // No aggregate score yet — clickable CTA fallback.
                <div className={styles.CombinedCta}>
                    {bureauLogo}
                    <img src={ctaPurpleRight} alt="" />
                    Combined Director Report
                </div>
            )}
        </div>
    );
}
